import { BaseMessage } from './messages';

export const MIN_LENGTH_CONSTRAINT = 500;
export const MAX_LENGTH_CONSTRAINT = 600000;

export class Reference {
  paragraphIndex: number;
  paragraphContent: string;

  constructor(paragraphIndex: number, paragraphContent: string) {
    this.paragraphIndex = paragraphIndex;
    this.paragraphContent = paragraphContent;
  }
}

export class ReviewMessage extends BaseMessage {
  references: Reference[];

  constructor(text: string, isBot: boolean, references: Reference[]) {
    super(text, isBot);
    this.references = references;
  }
}

export class ReviewChat {
  documentParagraphs: string[];
  messages: ReviewMessage[];
  pickle: string;

  constructor(
    documentParagraphs: string[],
    messages: ReviewMessage[],
    pickle: string
  ) {
    this.documentParagraphs = documentParagraphs;
    this.messages = messages;
    this.pickle = pickle;
  }
}

export class KeyPoint {
  id?: string;
  title: string;
  description: string;
  references: Reference[];
  explanation: string;

  constructor(
    title: string,
    description: string,
    references: Reference[],
    explanation: string
  ) {
    this.explanation = explanation;
    this.title = title;
    this.description = description;
    this.references = references;
  }
}

export class KeyPointResponse {
  keyPoints: KeyPoint[];
  conclusion: string;

  constructor(keyPoints: KeyPoint[], conclusion: string) {
    this.keyPoints = keyPoints;
    this.conclusion = conclusion;
  }
}
